// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/coge/piano-conti?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, societaId, parentId, livello, segmento, codice, descrizione, note, movimentabile, natura, sottotipo, attivo, figli }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/banche?societaId=',
    requestBody: null,
    response: '[{ id, nome, iban, attiva }]'
  },
  {
    method: 'POST',
    endpoint: '/api/coge/piano-conti',
    requestBody: '{ societaId, parentId, segmento, descrizione, note, movimentabile, natura, sottotipo }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/coge/piano-conti/:id',
    requestBody: '{ descrizione, note, sottotipo, bancaId, mostraInAnagraficaArticoli }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/coge/piano-conti/:id/stato',
    requestBody: '{ attivo }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/coge/piano-conti/:id',
    requestBody: null,
    response: '{ success: true }'
  },
  {
    method: 'GET',
    endpoint: '/api/coge/piano-conti/export?societaId=',
    requestBody: null,
    response: 'CSV (Content-Disposition: attachment)'
  },
  {
    method: 'POST',
    endpoint: '/api/coge/piano-conti/import/preview',
    requestBody: 'FormData{ file, societaId }',
    response: '{ success: true, data: { righe: [...], summary: {...} } }'
  },
  {
    method: 'POST',
    endpoint: '/api/coge/piano-conti/import/apply',
    requestBody: '{ societaId, conflictPolicy, righe }',
    response: '{ success: true, data: { creati, aggiornati, saltati } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
